import React, { useEffect, useState } from 'react';
import './home.css'
import Carousel from 'react-bootstrap/Carousel';
import { Accordion, Form } from 'react-bootstrap';

import Banner from '../components/banner/banner'
import FoundUs from '../components/foundUs/foundUs'
import Popup from '../components/popup/popup'
import Customer from '../components/customer/customer'
import 'react-multi-carousel/lib/styles.css';


function Home() {
 

  return (
    <>
    <div className='container bg-white p-3 m-3'>
      <div className='title pb-2'>
        <h6>صفحه اصلی</h6>
      </div>
      <div className=''>
      <Accordion >
          <div className=' [&>div]:px-2 [&>div]:py-3'>
            <div className='12'>
              <Accordion.Item eventKey="0">
                <Accordion.Header>بنر اصلی</Accordion.Header>
                <Accordion.Body>
                  <Banner slug="home2"/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="1">
                <Accordion.Header>بخش بن آیس را بیشتر بشناسید</Accordion.Header>
                <Accordion.Body>
                  <FoundUs/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="2">
                <Accordion.Header>مدیریت پاپ آپ</Accordion.Header>
                <Accordion.Body>
                  <Popup/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="3">
                <Accordion.Header>مشتریان بن آیس</Accordion.Header>
                <Accordion.Body>
                  <Customer/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
           
          </div>
        </Accordion>
      </div>
    </div>
    </>
  );
}

export default Home;
